export default __webpack_public_path__ + "static/media/shipment-color.79828ae5.svg";